import { Table } from 'antd'
import { ColumnsType } from 'antd/es/table'
import { t } from 'i18next'
import { useMemo } from 'react'
import { useParams } from 'react-router-dom'
import { styled } from 'styled-components'
import { SectionLoadingState } from '../../../../components'
import { NO_DATA_PLACEHOLDER } from '../../../../constants/constants'
import { useAlgorithmRunDetails } from '../../../../hooks'
import {
  FlowCytometryNodeResult,
  FlowCytometryReviewAnalysisRunResult,
  ReviewAnalysisGateLockReviewRow,
} from '../../../../store/reducers/workspaceReducer'
import { SmartFunctionListPanelLayout } from '../../components/SmartFunctionListPanelLayout'

const SectionLoadingStateContainer = styled.div`
  display: flex;
  height: calc(100vh - 224px);
`

interface ExtendedReviewAnalysisGateLockReviewRow extends ReviewAnalysisGateLockReviewRow {
  key: string
}

const FlowCytometryReviewAnalysisGateLockReviewPanel = () => {
  const { workspaceId, algorithmRunId } = useParams()

  const { loading, selectedAlgorithmRun } = useAlgorithmRunDetails({
    workspaceId,
    algorithmRunId,
    preventFetch: true,
  })

  const nodeResults = useMemo(
    () =>
      selectedAlgorithmRun?.nodeResults
        ? ((selectedAlgorithmRun?.nodeResults as FlowCytometryNodeResult)
            ?.REVIEW_ANALYSIS as FlowCytometryReviewAnalysisRunResult)
        : undefined,
    [selectedAlgorithmRun],
  )

  const formattedData: ExtendedReviewAnalysisGateLockReviewRow[] = useMemo(
    () =>
      nodeResults && nodeResults.gateLockReview
        ? nodeResults.gateLockReview.map(
            (gate: ReviewAnalysisGateLockReviewRow) =>
              ({
                ...gate,
                key: `${gate.patientId}-${gate.filename}`,
              }) as ExtendedReviewAnalysisGateLockReviewRow,
          )
        : [],
    [nodeResults],
  )

  // const formattedData: ExtendedReviewAnalysisGateLockReviewRow[] = [
  //   {
  //     key: '1',
  //     patientId: 'A01-002',
  //     filename: 'ADO0007P0007P_CTRL_A_F10_006.fcs',
  //     gatesLocked: true,
  //     severity: 'CRITICAL',
  //   },
  // ]

  const columns: ColumnsType<ReviewAnalysisGateLockReviewRow> = useMemo(
    () => [
      {
        title: t(
          'smartFunctionDetailsPage.cellCartaFlowCytometryReviewAnalysis.tableTitles.filename',
        ),
        dataIndex: 'filename',
        key: 'filename',
        width: '50%',
        render: (text, record) => <>{text || NO_DATA_PLACEHOLDER}</>,
      },

      {
        title: t(
          'smartFunctionDetailsPage.cellCartaFlowCytometryReviewAnalysis.tableTitles.gatesLocked',
        ),
        dataIndex: 'gatesLocked',
        key: 'gatesLocked',
        width: '50%',
        render: (value, record) => (
          <>
            {value === true
              ? t('True')
              : value === false
                ? t('False')
                : NO_DATA_PLACEHOLDER}
          </>
        ),
      },
    ],
    [],
  )

  return loading ? (
    <SectionLoadingStateContainer>
      <SectionLoadingState />
    </SectionLoadingStateContainer>
  ) : (
    <SmartFunctionListPanelLayout>
      <Table
        columns={columns}
        dataSource={formattedData}
        loading={loading}
        rowKey="key"
        pagination={false}
        scroll={{ y: 'calc(100vh - 190px)' }}
        rowClassName="page-list-table-row"
      />
    </SmartFunctionListPanelLayout>
  )
}

export default FlowCytometryReviewAnalysisGateLockReviewPanel
